const JP_Data = [
    {
        children: [
            {
                productId: '14823500448111',
                variantId: '52366821359983',
                name: 'white',
                rHref: 'https://www.amazon.co.jp/dp/B0G4M6RDY3',
            },
            {
                productId: '14823500448111',
                variantId: '52366821392751',
                name: 'black',
                rHref: 'https://www.amazon.co.jp/dp/B0G7FJF7VJ',
            },
        ],
        type: 'power-bank',
        show: 'statusD',
        new: true,
        spec: true, // 是否在最下面 spec 模块出现
    },
    {
        children: [
            {
                productId: '14816159826287',
                variantId: '52339449954671',
                name: 'black',
                rHref: 'https://www.amazon.co.jp/dp/B0FWJSLF4Y',
            },
            {
                productId: '14816159826287',
                variantId: '52339579486575',
                name: 'white',
                //rHref: 'https://www.amazon.co.jp/dp/B0FWJSLF4Y',
                lDisabled: true,
            },
        ],
        type: 'power-bank',
        new: true,
        spec: true,
    },

    // Q1
    {
        children: [
            {
                productId: '14718195564911',
                variantId: '52003665576303',
                name: 'white',
                rHref: 'https://www.amazon.co.jp/dp/B0FCY39MTC',
            },
            {
                productId: '14718195564911',
                variantId: '52003665510767',
                name: 'black',
                lDisabled: true,
            },
            {
                productId: '14718195564911',
                variantId: '52003665609071',
                name: 'purple',
                lDisabled: true,
            },
            {
                productId: '14718195564911',
                variantId: '52003665543535',
                lDisabled: true,
                name: 'green',
            },
            {
                productId: '14718195564911',
                variantId: '52003679601007',
                lDisabled: true,
                name: 'pink',
            },
        ],
        spec: true,
        type: 'power-bank',
    },
    {
        children: [
            {
                productId: '14718204379503',
                variantId: '52003754574191',
                name: 'white',
                rHref: 'https://www.amazon.co.jp/dp/B0FCXC7RKH',
            },
            {
                productId: '14718204379503',
                variantId: '52003754541423',
                lDisabled: true,
                name: 'black',
            },
            {
                productId: '14718204379503',
                variantId: '52003754606959',
                lDisabled: true,
                name: 'purple',
            },
            {
                productId: '14718204379503',
                variantId: '52003754639727',
                lDisabled: true,
                name: 'green',
            },
            {
                productId: '14718204379503',
                variantId: '52003754672495',
                lDisabled: true,
                name: 'pink',
            },
        ],
        spec: true,
        type: 'power-bank',
    },

    // Q2
    {
        children: [
            {
                productId: '14630813466991',
                variantId: '51675870364015',
                name: 'black',
            },
            {
                productId: '14630813466991',
                variantId: '51675869249903',
                name: 'silver',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573309/50-blue.png',
                productId: '14630813466991',
                variantId: '52047990882671',
                name: 'blue',
            },
        ],
        type: 'power-bank',
    },
    {
        children: [
            {
                productId: '14631171883375',
                variantId: '51670335816047',
                name: 'black',
            },
            {
                productId: '14631171883375',
                variantId: '51670335750511',
                name: 'silver',
            },
        ],
        type: 'power-bank',
    },

    // 配件
    {
        children: [
            {
                productId: '14816166052207',
                variantId: '52339479937391',
                name: 'black',
                rHref: 'https://www.amazon.co.jp/dp/B0FWJR6NLX',
            },
            {
                productId: '14816166052207',
                variantId: '52339564773743',
                name: 'white',
                lDisabled: true,
                // rHref: 'https://www.amazon.co.jp/dp/B0FWJR6NLX',
            },
        ],
        new: true,
        type: 'charger',
    },
    {
        children: [
            {
                productId: '14789516820847',
                variantId: '52218084491631',
                name: 'black',
                rHref: 'https://www.amazon.co.jp/dp/B0FPFTJ17F',
            },
            {
                productId: '14789516820847',
                variantId: '52218084458863',
                name: 'white',
                rHref: 'https://www.amazon.co.jp/dp/B0FPFTJ17F',
            },
        ],
        rHref: '',
        new: true,
        type: 'charger',
    },
];

export default {
    jp: JP_Data,
};
